import type { DeepPartial } from '@luna/utils-ts';

import type { Pay } from './Pay';

export const RS: DeepPartial<Pay> = {
    csto: { enabled: true },
    ABService: { enabled: true },
};
